import type { AsyncThunkApiConfig } from '@/store'
import type { RejectError } from '../../typings'

import { createAsyncThunk } from '@reduxjs/toolkit'

interface Payload {
  recurrence: uui.domain.rm.Recurrence
  assignments: Record<string, string | null>
}

/**
 * Update driverAssignments
 *
 * @private
 */
export const updateDriverAssignments = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/driverAssignment/update', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const result = await rpc('rpc/driverAssignment/update', {
      category: 'rpc',
      type: 'rpc/driverAssignment/update',
      ...payload,
    })
    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {updateDriverAssignments}`,
      { tags: ['rpc', 'driverAssignments'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update driverAssignments failed`,
      error,
    })
  }
})
